(() => {
  if (window.ltProductReviewsReady || !document.querySelector('[data-lt-reviews]')) return;
  window.ltProductReviewsReady = true;
  const romanian = document.documentElement.lang.toLowerCase().startsWith('ro');
  const roots = '#trustshop-review, .trustshop-form-review--container, .trustshop-review--overlay, .trustshop-report--overlay, .trustshop--tooltip';
  // Never rewrite customer names, review titles/content, replies, dates, input values or app data.
  const protectedContent = '.trustshop-review--title, .trustshop-review--content, .trustshop-review--author, .trustshop-reply--box, time, script, style, textarea, input';
  const translations = new Map(Object.entries({
    'Review-uri': 'Recenzii', 'Review': 'Recenzie', 'Titlu Review': 'Titlul recenziei',
    'Adauga un review': 'Scrie o recenzie', 'Trimite Review': 'Trimite recenzia',
    'Spune-ti parerea acordand o nota produsului': 'Spune-ne părerea ta despre acest produs.',
    'Review-uri cu imagini': 'Recenzii cu imagini', 'All ratings': 'Toate notele',
    'Sorteaza dupa': 'Sortează după', 'Cele mai utile': 'Cele mai utile',
    'Cele mai recente': 'Cele mai recente', 'Most recent': 'Cele mai recente',
    'Highest rating': 'Nota cea mai mare', 'Lowest rating': 'Nota cea mai mică',
    'Most helpful': 'Cele mai utile', 'Raporteaza': 'Raportează',
    'Data transmitere': 'Publicată la ', 'Nume client': 'Nume', 'Email client': 'E-mail',
    'Your name will appear as': 'Numele tău va apărea ca ',
    'Format de afisare a numelui': 'Formatul de afișare a numelui',
    'Introduceti adresa dvs. de e-mail aici': 'Introdu adresa ta de e-mail.',
    'Generate with AI': 'Ajutor la redactare cu AI', 'Upload media': 'Adaugă fotografii sau videoclipuri',
    'Upload up to 5 photos & 2 videos drag & drop or': 'Adaugă până la 5 fotografii și 2 videoclipuri. Trage fișierele aici sau ',
    'click here': 'apasă aici', 'to upload files': ' pentru a le încărca',
    '*Va rugam sa completati acest camp': '* Completează acest câmp.',
    'Fii primul care scrie un review.': 'Fii primul care scrie o recenzie.',
    'Write your first review': 'Scrie prima recenzie', 'Submit review': 'Trimite recenzia',
    'Enter review title': 'Titlul recenziei', 'Enter your review': 'Recenzia ta',
    'Enter your name': 'Numele tău', 'Enter your email address': 'Adresa ta de e-mail',
    'Exemplu: Usor de montat': 'Exemplu: Ușor de montat',
    'Spune-ne daca iti place sau nu ce ti-ai luat si daca ai recomanda si altora': 'Descrie experiența ta cu produsul și dacă l-ai recomanda.',
    'Filter by all': 'Toate recenziile', 'Filter by review with photos': 'Recenzii cu imagini',
    'Mark review as helpful': 'Marchează recenzia ca utilă', 'Report this review': 'Raportează recenzia',
    'Raporteaza acest review': 'Raportează această recenzie', 'Raporteaza acest review.': 'Raportează această recenzie',
    'Submit report': 'Trimite raportarea',
    'Review-ul contine informatii private.': 'Recenzia conține informații private.',
    'Review-ul contine un limbaj inacceptabil.': 'Recenzia conține un limbaj inacceptabil.',
    'Review-ul contine publicitate sau spam.': 'Recenzia conține publicitate sau spam.',
    'Review-ul contine continut violent si dezgustator.': 'Recenzia conține conținut violent sau ofensator.',
    'Alte incalcari.': 'Alte încălcări.'
  }));
  function translate(text) {
    const clean = text.replace(/\s+/g, ' ').trim();
    if (translations.has(clean)) return translations.get(clean);
    if (/^\d+ (?:Review-uri|Reviews?)$/.test(clean)) return clean.replace(/(?:Review-uri|Reviews?)$/, clean.startsWith('1 ') ? 'recenzie' : 'recenzii');
    if (/^Your name will appear as /.test(clean)) return clean.replace('Your name will appear as ', 'Numele tău va apărea ca ');
    const star = clean.match(/^(?:Rate )?([1-5]) stars?(?: filter)?$/);
    if (star) return `${star[1]} ${star[1] === '1' ? 'stea' : 'stele'}`;
    return text;
  }
  function localize(root) {
    if (!romanian) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, { acceptNode: node =>
      node.parentElement?.closest(protectedContent) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT
    });
    let node;
    while ((node = walker.nextNode())) { const next = translate(node.nodeValue); if (next !== node.nodeValue) node.nodeValue = next; }
    // App expansion controls can be inside a protected merchant reply. Translate
    // only that identified control; never traverse or rewrite the reply itself.
    root.querySelectorAll('.trustshop-button-show-full--review').forEach(el => {
      const labels = { More: 'Mai mult', Less: 'Mai puțin' };
      const next = labels[el.textContent.trim()];
      if (next && !el.children.length) el.textContent = next;
    });
    root.querySelectorAll('[aria-label], [placeholder], [title]').forEach(el => {
      if (el.closest('.trustshop-review--content, .trustshop-review--title, .trustshop-reply--box')) return;
      ['aria-label', 'placeholder', 'title'].forEach(attr => {
        const old = el.getAttribute(attr); if (!old) return;
        const next = translate(old); if (next !== old) el.setAttribute(attr, next);
      });
    });
    root.querySelectorAll('.trustshop-close-modal--btn').forEach(el => el.setAttribute('aria-label', 'Închide formularul'));
  }
  function summary() {
    const widget = document.querySelector('#trustshop-review');
    const heading = document.querySelector('main .product-details h1');
    if (!widget || !heading) return;
    const rating = Number(widget.querySelector('.trustshop-rating > span:first-child')?.textContent.trim().replace(',', '.'));
    const count = parseInt(widget.querySelector('.trustshop-total-rating')?.textContent, 10);
    let link = document.querySelector('[data-lt-review-summary]');
    if (!(count > 0 && rating > 0 && rating <= 5)) { link?.remove(); return; }
    if (!link) {
      link = document.createElement('a'); link.href = '#trustshop-review'; link.className = 'lt-review-summary'; link.dataset.ltReviewSummary = '';
      const stars = document.createElement('span'); stars.className = 'lt-review-summary__stars'; stars.setAttribute('aria-hidden', 'true'); stars.textContent = '★★★★★';
      const fill = document.createElement('span'); fill.textContent = '★★★★★'; stars.append(fill);
      const label = document.createElement('span'); label.dataset.ltReviewLabel = '';
      link.append(stars, label); (heading.parentElement.querySelector('.lt-product-code') || heading).after(link);
    }
    link.style.setProperty('--rating-fill', `${rating / 5 * 100}%`);
    const label = `${rating.toLocaleString(romanian ? 'ro-RO' : 'en', { maximumFractionDigits: 1 })}/5 · ${count} ${romanian ? (count === 1 ? 'recenzie' : 'recenzii') : 'reviews'}`;
    const target = link.querySelector('[data-lt-review-label]'); if (target.textContent !== label) target.textContent = label;
  }
  function update() {
    document.querySelectorAll(roots).forEach(localize);
    const heading = document.querySelector('#trustshop-review .trustshop-header--title');
    if (heading) { heading.setAttribute('role', 'heading'); heading.setAttribute('aria-level', '2'); }
    const form = document.querySelector('#trustshop-form-review--container');
    if (form) { form.setAttribute('role', 'dialog'); form.setAttribute('aria-modal', 'true'); form.setAttribute('aria-label', romanian ? 'Scrie o recenzie' : 'Write a review'); }
    summary();
  }
  let scheduled = false;
  const observer = new MutationObserver(records => {
    if (!records.some(r => r.target.parentElement?.closest(roots) || (r.target instanceof Element && r.target.closest(roots)) || [...r.addedNodes].some(n => n instanceof Element && (n.matches(roots) || n.querySelector(roots))))) return;
    if (scheduled) return; scheduled = true;
    requestAnimationFrame(() => { scheduled = false; update(); });
  });
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-lt-review-summary]')) return;
    document.querySelector('#trustshop-review')?.focus({ preventScroll: true });
  });
  document.addEventListener('keydown', event => {
    const form = document.querySelector('#trustshop-form-review--container.show-form-write--review');
    if (!form || !form.contains(document.activeElement)) return;
    if (event.key === 'Escape') { event.preventDefault(); form.querySelector('.trustshop-close-modal--btn')?.click(); document.querySelector('#trustshop-write--review')?.focus(); }
    if (event.key === 'Tab') {
      const controls = [...form.querySelectorAll('button, input, textarea, select, a[href], [tabindex="0"]')].filter(el => !el.disabled && el.getClientRects().length);
      const first = controls[0], last = controls.at(-1);
      if (event.shiftKey && (document.activeElement === first || document.activeElement === form)) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    }
  });
  update();
})();
